'use client';

import {
  aiGeneratedImageCaptionAtom,
  codeThemeAtom,
  enableKatexAtom,
  enablePostNewsletterAtom,
  extractCoverImageAtom,
  postCssAtom,
  postJsAtom,
  postNewsletterDescriptionAtom,
  postNewsletterTitleAtom,
  publishAtAtom,
  publishedDateTypeAtom,
  shareListAtom,
  showBreadcrumbAtom,
  showCodeLineNumberAtom,
  showCommentAtom,
  showExcerptAtom,
  showLikeAtom,
  showMoreFromAtom,
  showPublishDateAtom,
  showReadTimeAtom,
  showTocAtom,
} from 'app/blog/[domain]/_components/design-state';
import type { SelectPostDesignSchema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

export type HydratePostAtoms = Partial<SelectPostDesignSchema> & {
  publishAt?: Date | null;
};

export function HydratePostAtoms(props: HydratePostAtoms) {
  const store = useStore();
  // Initialize optional values too: later RSC refreshes must not hydrate
  // newly populated fields while design controls are already subscribed.
  useHydrateAtoms(
    [
      [showBreadcrumbAtom, props.showBreadcrumb ?? showBreadcrumbAtom.init],
      [showReadTimeAtom, props.showReadTime ?? showReadTimeAtom.init],
      [showExcerptAtom, props.showExcerpt ?? showExcerptAtom.init],
      [
        extractCoverImageAtom,
        props.extractCoverImage ?? extractCoverImageAtom.init,
      ],
      [shareListAtom, props.shareList ?? shareListAtom.init],
      [showPublishDateAtom, props.showPublishDate ?? showPublishDateAtom.init],
      [
        publishedDateTypeAtom,
        props.publishedDateType ?? publishedDateTypeAtom.init,
      ],
      [
        aiGeneratedImageCaptionAtom,
        props.aiGeneratedImageCaption ?? aiGeneratedImageCaptionAtom.init,
      ],
      [
        showCodeLineNumberAtom,
        props.showCodeLineNumber ?? showCodeLineNumberAtom.init,
      ],
      [enableKatexAtom, props.enableKatex ?? enableKatexAtom.init],
      [codeThemeAtom, props.codeTheme ?? codeThemeAtom.init],
      [showTocAtom, props.showToc ?? showTocAtom.init],
      [showCommentAtom, props.showComment ?? showCommentAtom.init],
      [showLikeAtom, props.showLike ?? showLikeAtom.init],
      [showMoreFromAtom, props.showMoreFrom ?? showMoreFromAtom.init],
      [
        enablePostNewsletterAtom,
        props.enablePostNewsletter ?? enablePostNewsletterAtom.init,
      ],
      [
        postNewsletterTitleAtom,
        props.postNewsletterTitle ?? postNewsletterTitleAtom.init,
      ],
      [
        postNewsletterDescriptionAtom,
        props.postNewsletterDescription ?? postNewsletterDescriptionAtom.init,
      ],
      [postCssAtom, props.customCss ?? postCssAtom.init],
      [postJsAtom, props.customJs ?? postJsAtom.init],
      [publishAtAtom, props.publishAt ?? publishAtAtom.init],
    ] as const,
    { store },
  );

  return <></>;
}
